export const gocars = "https://gocars.goibibo.com/";
export const cabsAutoComplete = `v1/google/places/autocomplete`;
export const GI_API_PREFIX = '/api/apps/v1'

export const srp = `/api/apps/v1/booking/srp/info/`;
export const review = '/api/apps/v1/booking/review/info';
export const pricereview = '/api/apps/v2/booking/review/pay';
export const blockapi  = '/api/apps/v7/booking/block/exclusive-cabs';
export const reviewsApi = '/api/apps/v1/customer/reviews';
export const smartEngageapi = '/api/v1/smart_engage/get_smart_ads/?flavour=v3&status=LIVE';
export const pagemakerapi = '/api/v1/pagemaker/get_rendered_template/?template_ids=';
export const calendarapi = '/api/v1/pagemaker/get_rendered_template/?template_ids=["calendar_json"]';
export const goCashInfoApi = '/gocash/v2/get_balance/'
export const hourlyRentalsDetails = '/api/apps/v1/booking/hourly_rental'
export const travellerInformationApi = '/api/apps/v1/user_info?flavour=cars_dweb'
export const hobHoldUrlMMT = '/nativeHold'
export const hobSearchQueryMMT = '/autocomplete/v3'
export const checkFareHob = '/provisional/checkFare/hob'
export const provisionalDetailsHob = '/provisional/detail/hob'
export const hobDriverData  = '/provisional/driver-detail/hob'
export const hobThankyouApi = '/provisional/thankyou/hob'
export const hobUserDetailsApi = '/api/apps/v1/user-info/hob'
export const hobUserDetailsApiMmt = '/user-info/hob'
export const fetchLocationDetailsMMT = '/fetchLocation?place_id'
export const fetchLocationDetails = '/v1/places/fetch/location?place_id'
export const cabConfigDataApi = `/api/apps/v1/config_data`

//pokus api
export const pokusApi = '/measurement/getDynamicConfigs'

// SEO API
export const SEO_ROUTE_API = "/gt_cab/api/v1/route_seo_data/";
export const SEO_CAR_CITY_API = "/gt_cab/api/v1/car_city_seo_data";
export const SEO_CITY_API = "/gt_cab/api/v1/city_seo_data/";
export const SEO_AIRPORT_CITY_API = "/gt_cab/api/v1/airport_seo_data/";
export const SEO_AIRPORT_ROUTE_API = "/gt_cab/api/v1/airport_route_seo_data/";
export const SEO_CAR_ROUTE_API = "/gt_cab/api/v1/car_route_seo_data/";
export const SEO_CAR_RENTAL_API = "/gt_cab/api/v1/hourly_rental_seo_data/";
export const SEO_QUERY_SUBMIT_API = "/api/apps/v1/seo/query_form_submit";
export const SEO_RYDE_ROUTE_API = "/gt_cab/api/v1/ryde_route_seo_data/";
export const QUERY_FORM_DATA_API = "/api/apps/v1/seo/query_form_data";
export const ONEWAY_INTERLINKING_API = "/gt_cab/api/v1/oneway_interlinks_data/";
export const SEO_MULTICITY_URL = "http://cabs-seo-data-loader.ecs.mmt/api/multiCityTemplateData/1?refreshMode=static&orgId=GI";
export const SHOW_SEO_LEADGEN = "SHOW_SEO_LEADGEN";
export const SHOW_INBOUND_CALL = "SHOW_INBOUND_CALL";
export const INBOUND_CONTACT_NUMBER = "INBOUND_CONTACT_NUMBER";
export const SHOW_SEO_LEAVE_INTENT = "SHOW_SEO_LEAVE_INTENT";
export const SEO_FORM_COUPON_DATA = "SEO_FORM_COUPON_DATA";

export const rydeAssuredBannerData = {
  heading:'Introducing Ryde Assured Partners',
  subHeading: `Travel with <span style="font-weight: 600">handpicked operator</span> just for you!`,
  iconName: 'RydeAssured',
  sliderList: [
      {
          iconName: "Professional",
          title: "Perfectly Professional",
          subTitle: "Ride with uniformed, verified drivers"
      },
      {
          iconName: "Sanitization",
          title: "Super Sanitization",
          subTitle: "Travel in audited, clean, hygienic vehicles"
      },
      {
          iconName: "Pricing",
          title: "Transparent Pricing",
          subTitle: "Accurate billing, inclusive of GST, State Tolls & Taxes"
      },
      {
          iconName: "GPS",
          title: "Live GPS Tracking",
          subTitle: "Enjoy live-tracking, while you wait"
      },
      {
          iconName: "Sound",
          title: "Superb Sound System",
          subTitle: "Groove to top-quality music as you travel"
      }
  ]
};

export const tripAttributes = [
  {
    name: "Outstation",
    sName: "One-way",
    tripType: "ONE_WAY",
    rf: "ow",
    title: "One pickup & drop to destination",
  },
  {
    name: "Outstation",
    sName: "Round trip",
    tripType: "ROUND_TRIP",
    rf: "rt",
    title: "Retain cab until return with multiple halts",
  },
  {
    name: "Airport",
    sName: "transfer",
    tripType: "AIRPORT",
    rf: "at",
    title: "Airport pickup & drop",
  },
  {
    name: "Hourly Rental",
    sName: "",
    tripType: "LOCAL_RENTAL",
    rf: "hr",
    title: "Hourly Rental",
  },
];

export const tripAttr = {
  ONE_WAY: {
    name: "Outstation Oneway",
    title: "One pick up & drop + halt for lunch",
    t: "One-way benefits",
    list: [
      "Special one-way fares to just get dropped off to your destination",
      "Experienced and polite drivers with well-serviced, comfortable cabs",
      "Prices inclusive of GST, state taxes and tolls on majority of the routes",
    ],
    rf: "ow"
  },
  ROUND_TRIP: {
    name: "Outstation RoundTrip",
    title: "Retain the cab through out the trip",
    rf: "rt"
  },
  AIRPORT: {
    name: "AIRPORT",
    title: "Airport pickup & drop",
    rf: "at"
  },
  LOCAL_RENTAL: {
    name: "Hourly Rental",
    title: "Hourly Rental",
    rf: "hr"
  }
};

export const popularRoutes = [
  {
    description: "Bangalore, Karnataka, India",
    loc_type: "city",
    matched_substrings: [
      {
        length: 3,
      },
    ],
    place_id: "ChIJbU60yXAWrjsR4E9-UejD3_g",
    reference: "ChIJbU60yXAWrjsR4E9-UejD3_g",
    region: "bengaluru",
    structured_formatting: {
      main_text: "Bangalore",
      secondary_text: "Karnataka, India",
    },
    terms: [
      {
        offset: 0,
        value: "Bangalore",
      },
      {
        offset: 11,
        value: "Karnataka",
      },
      {
        offset: 22,
        value: "India",
      },
    ],
    types: ["locality", "political", "geocode"],
  },
  {
    description: "Mysuru, Karnataka, India",
    loc_type: "city",
    matched_substrings: [
      {
        length: 6,
      },
    ],
    place_id: "ChIJ-S5XHThwrzsRbTn4wOjsiSs",
    reference: "ChIJ-S5XHThwrzsRbTn4wOjsiSs",
    region: "mysuru",
    structured_formatting: {
      main_text: "Mysuru",
      secondary_text: "Karnataka, India",
    },
    terms: [
      {
        offset: 0,
        value: "Mysuru",
      },
      {
        offset: 8,
        value: "Karnataka",
      },
      {
        offset: 19,
        value: "India",
      },
    ],
    types: ["locality", "political", "geocode"],
  },
];

export const topRoutes = [
  {
    url: "https://www.goibibo.com/cars/delhi-to-jaipur-cabs/",
    text: "Delhi To Jaipur Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-agra-cabs/",
    text: "Delhi To Agra Cab",
  },
  {
    url: "https://www.goibibo.com/cars/mumbai-to-pune-cabs/",
    text: "Mumbai To Pune Cab",
  },
  {
    url: "https://www.goibibo.com/cars/pune-to-mumbai-cabs/",
    text: "Pune To Mumbai Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-chandigarh-cabs/",
    text: "Delhi To Chandigarh Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-dehradun-cabs/",
    text: "Delhi To Dehradun Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-haridwar-cabs/",
    text: "Delhi To Haridwar Cab",
  },
  {
    url: "https://www.goibibo.com/cars/chandigarh-to-shimla-cabs/",
    text: "Chandigarh To Shimla Cab",
  },
  {
    url: "https://www.goibibo.com/cars/chennai-to-pondicherry-cabs/",
    text: "Chennai To Pondicherry Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-mathura-cabs/",
    text: "Delhi To Mathura Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-haldwani-cabs/",
    text: "Delhi To Haldwani Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-manali-cabs/",
    text: "Delhi To Manali Cab",
  },
  {
    url: "https://www.goibibo.com/cars/bangalore-to-mysore-cabs/",
    text: "Bangalore To Mysore Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-rishikesh-cabs/",
    text: "Delhi To Rishikesh Cab",
  },
  {
    url: "https://www.goibibo.com/cars/jaipur-to-delhi-cabs/",
    text: "Jaipur To Delhi Cab",
  },
  {
    url: "https://www.goibibo.com/cars/dehradun-to-delhi-cabs/",
    text: "Dehradun To Delhi Cab",
  },
  {
    url: "https://www.goibibo.com/cars/bhubaneswar-to-puri-cabs/",
    text: "Bhubaneswar To Puri Cab",
  },
  {
    url: "https://www.goibibo.com/cars/siliguri-to-gangtok-cabs/",
    text: "Siliguri To Gangtok Cab",
  },
  {
    url: "https://www.goibibo.com/cars/delhi-to-bareilly-cabs/",
    text: "Delhi To Bareilly Cab",
  },
  {
    url: "https://www.goibibo.com/cars/mysore-to-coorg-cabs/",
    text: "Mysore To Coorg Cab",
  },
  {
    url: "https://www.goibibo.com/cars/mumbai-to-goa-cabs/",
    text: "Mumbai To Goa Cab",
  },
  {
    url: "https://www.goibibo.com/cars/ahmedabad-to-vadodara-cabs/",
    text: "Ahmedabad To Vadodara Cab",
  },
  {
    url: "https://www.goibibo.com/cars/bangalore-to-hyderabad-cabs/",
    text: "Bangalore To Hyderabad Cab",
  },
];

export const topCityFrom = [
  {
    url: "https://www.goibibo.com/cars/cab-from-delhi/",
    text: "Delhi Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-goa/",
    text: "Goa Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-bangalore/",
    text: "Bangalore Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-chennai/",
    text: "Chennai Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-patna/",
    text: "Patna Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-hyderabad/",
    text: "Hyderabad Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-kolkata/",
    text: "Kolkata Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-jaipur/",
    text: "Jaipur Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-pune/",
    text: "Pune Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-chandigarh/",
    text: "Chandigarh Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-coimbatore/",
    text: "Coimbatore Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-indore/",
    text: "Indore Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-mumbai/",
    text: "Mumbai Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-visakhapatnam/",
    text: "Visakhapatnam Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-gurgaon/",
    text: "Gurgaon Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-tirupati/",
    text: "Tirupati Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-ahmedabad/",
    text: "Ahmedabad Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-varanasi/",
    text: "Varanasi Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-noida/",
    text: "Noida Taxi Services",
  },
  {
    url: "https://www.goibibo.com/cars/cab-from-raipur/",
    text: "Raipur Taxi Services",
  },
];

export const topCityTo = [
  {
    url: "https://www.goibibo.com/cars/cab-to-bangalore/",
    text: "Cab To Bangalore",
  },
  { url: "https://www.goibibo.com/cars/cab-to-jaipur/", text: "Cab To Jaipur" },
  { url: "https://www.goibibo.com/cars/cab-to-agra/", text: "Cab To Agra" },
  { url: "https://www.goibibo.com/cars/cab-to-delhi/", text: "Cab To Delhi" },
  {
    url: "https://www.goibibo.com/cars/cab-to-mahabaleshwar/",
    text: "Cab To Mahabaleshwar",
  },
  { url: "https://www.goibibo.com/cars/cab-to-patna/", text: "Cab To Patna" },
  { url: "https://www.goibibo.com/cars/cab-to-manali/", text: "Cab To Manali" },
  { url: "https://www.goibibo.com/cars/cab-to-nasik/", text: "Cab To Nasik" },
  {
    url: "https://www.goibibo.com/cars/cab-to-mangalore/",
    text: "Cab To Mangalore",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-jodhpur/",
    text: "Cab To Jodhpur",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-muzaffarnagar/",
    text: "Cab To Muzaffarnagar",
  },
  { url: "https://www.goibibo.com/cars/cab-to-pune/", text: "Cab To Pune" },
  { url: "https://www.goibibo.com/cars/cab-to-noida/", text: "Cab To Noida" },
  {
    url: "https://www.goibibo.com/cars/cab-to-raigarh/",
    text: "Cab To Raigarh",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-hoshiarpur/",
    text: "Cab To Hoshiarpur",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-hyderabad/",
    text: "Cab To Hyderabad",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-madurai/",
    text: "Cab To Madurai",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-kaithal/",
    text: "Cab To Kaithal",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-jaisalmer/",
    text: "Cab To Jaisalmer",
  },
  {
    url: "https://www.goibibo.com/cars/cab-to-kurukshetra/",
    text: "Cab To Kurukshetra",
  },
];

export const topAirportRoutes = [
  {
    url: "https://www.goibibo.com/cars/cabs-from-bangalore-airport/",
    text: "Cab From Bangalore Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-hyderabad-airport/",
    text: "Cab From Hyderabad Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-delhi-airport/",
    text: "Cab From Delhi Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-chennai-airport/",
    text: "Cab From Chennai Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-bangalore-airport/",
    text: "Cab From Bangalore Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-ahmedabad-airport/",
    text: "Cab From Ahmedabad Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-kolkata-airport/",
    text: "Cab From Kolkata Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-amritsar-airport/",
    text: "Cab From Amritsar Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-chandigarh-airport/",
    text: "Cab From Chandigarh Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-chennai-airport/",
    text: "Cab From Chennai Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-jaipur-airport/",
    text: "Cab From Jaipur Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-patna-airport/",
    text: "Cab From Patna Airport",
  },
  {
    url: "https://www.goibibo.com/cars/cabs-from-madurai-airport/",
    text: "Cab From Madurai Airport",
  },
  {
    url:
      "https://www.goibibo.com/cars/pune-to-mumbai-airport-cabs-bom-ca-cabs/",
    text: "Pune To Mumbai Airport Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/ernakulam-airport-to-munnar-cabs-cok-ac-cabs/",
    text: "Ernakulam Airport To Munnar Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/srinagar-airport-to-gulmarg-cabs-sxr-ac-cabs/",
    text: "Srinagar Airport To Gulmarg Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/chandigarh-to-delhi-airport-cabs-del-ca-cabs/",
    text: "Chandigarh To Delhi Airport Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/chennai-airport-to-pondicherry-cabs-maa-ac-cabs/",
    text: "Chennai Airport To Pondicherry Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/mumbai-airport-to-thane-cabs-bom-ac-cabs/",
    text: "Mumbai Airport To Thane Cab",
  },
  {
    url:
      "https://www.goibibo.com/cars/mumbai-airport-to-pune-cabs-bom-ac-cabs/",
    text: "Mumbai Airport To Pune Cab",
  },
];

export const SEO_ROUTE_STATIC_CONTENT = '<h2>Online Cab Booking on GoIbibo </h2> <p>Most of the Indian tourists prefer travelling to their preferred destination via road. It is due to the fact that a road trip allows you to enjoy the scenic beauty at your own pace. Moreover, the comfort of travelling in a vehicle with your family and friends is unparalleled. You can opt for online cab booking that will make your journey hassle-free. You simply have to visit the GoIbibo portal and select a cab.</p> <p>Due to the easy-to-use interface and quick menu options of GoIbibo, online cab booking is not a difficult process. In fact, cab booking is something which has become a part of our everyday life. You can also opt for intercity car rentals in order to visit other cities.</p> <p>The online taxi booking process on GoIbibo can be completed within a couple of minutes. So, if you wish to customize your cab booking package, GoIbibo is your go-to website. All the car booking services available on GoIbibo are geared towards giving you the best-possible experience when it comes to cab booking.</p> <h2>Book Your Cab Online </h2> <p>When you choose us for your cab booking requirements, we offer you premium services, and most importantly, high reliability. GoIbibo is considered one of the most popular car booking platforms. Besides that, you can also visit the website for train, flight, and bus tickets. The best part is you can get top-notch cars for your preferred destination.</p> <p>Road trips are one of the most exciting ways to travel all across the country. There is so much to experience and explore. GoIbibo ensures that your road trip is an enjoyable experience.</p> <p>The process of booking a cab on GoIbibo is pretty simple. You just need to log in to GoIbibo&apos;s official website and provide all the required details. In order to book your cab, you have to fill in the city of your origin, the destination, your departure date and timings. Once all the details are filled, simply click on the &lsquo;Search&rsquo; option.</p> <p>On the portal, you will get a wide range of cab options available at different prices. The prices depend on a lot of factors such as the type of cab you are choosing, the in-car facilities provided, the route you are taking to travel as well as your date of journey. You can select a cab which meets your travel requirements.</p> <h2>Book a Cab for an Exciting Road Trip </h2> <p>Tourists enjoy the scenic beauty of nature, the smooth highway roads, studying the diverse cultures and tasting the lip-smacking local food once when you are on holiday. There is a lot you can explore on a road trip, and GoIbibo is there to be your travel companion.</p> <p>You can book outstation cab to visit popular tourist destinations such as Delhi, Manali, Mumbai and Naintal or the unexplored gems such as Khajuraho, Alleppey, Alibag and Tranquebar simply by booking an online cab booking. Planning a trip can be quite a hassle, but choose to make your online cab booking on GoIbibo for an easier process. You can choose from a wide range of cabs such as hatchbacks, sedans, SUVs, MPVs, and more. You can also book an outstation cab for a one-way trip as well as a round trip.</p> <p>In case you have any booking-related queries, you can reach out to the 24/7 customer service of GoIbibo and talk to the experts regarding your travel. While booking your outstation cab with us, you can also get assistance in discussing the itinerary and planning your trip. Moreover, the option of using the mobile app will further reduce the hassle of booking a cab. All the services offered by GoIbibo are available on a single click. Moreover, you can also get exciting discounts and offers if you make your bookings via GoIbibo.</p> <h2>Choose GoIbibo for Online Cab Booking </h2> <p>GoIbibo can make the process of online cab booking hassle-free. Below, we are mentioning some of the reasons why people choose us over and over again:</p> <h2>Clean cars </h2> <p>Hygiene is the top-most priority for GoIbibo. That&rsquo;s why, they ensure that the cab you book is absolutely clean. Considering the Covid-19 situation, we ensure that every car is sanitized before the journey and all the safety protocols are followed thoroughly. The temperature of drivers is checked before every trip, and wearing masks is mandatory for the passengers as well as drivers.</p> <h2>Transparent billing </h2> <p>Be assured, when you choose GoIbibo for your cab booking requirements, the services offered are at the most reasonable rates. Besides that, GoIbibo also maintains 100% billing transparency. So, there are zero hidden charges involved from the beginning to end of your journey. You can choose from your preferred payment methods. Some of the payment options available on GoIbibo include debit card, credit card, net banking and UPI.</p> <h2>Reliable services </h2> <p>Every person is looking for a reliable experience that prioritizes their needs and concerns. That&rsquo;s why, GoIbibo offers an unparalleled experience to users when they are making cab booking online. You can connect with the 24/7 customer support service of GoIbibo and resolve all your booking-related queries. From providing the best services to ensuring a safe trip, GoIbibo makes sure that your trip is enjoyable.</p> <h2>Courteous chauffeurs </h2> <p>Dealing with impolite people is difficult. An encounter with a rude person can ruin our entire trip. That&rsquo;s why, GoIbibo makes sure that the chauffeur you get is polite and cooperative. You can find the top-rated drivers on GoIbibo who will make your journey smooth and your trip memorable.</p> <h2>Road trip experts </h2> <p>GoIbibo turns you into an expert in planning road trips. The easy access to all the travel services can help you plan your travel accurately. You can reach out to the customer centre of GoIbibo. Our team comprises experts who offer the best solutions for your queries. Therefore, cab booking with GoIbibo is always a hassle-free experience. Whether it is for outstation trips or an <a href="https://www.goibibo.com/cars/airport-cabs/">airport taxi</a>, GoIbibo can meet all your travel requirements so that you can reach your desired destination safely. GoIbibo believes in assuring safety, reliability, and affordability to travelers.</p>';
export const DEFAULT_RENTAL_PACKAGE = "PKG_20_2";

// Action Names
export const UPDATE_SEO_FLOW          = 'UPDATE_SEO_FLOW';
export const UPDATE_RECENT_SEARCH     = 'UPDATE_RECENT_SEARCH';
export const UPDATE_QUERY_FIELDS_DATA = 'UPDATE_QUERY_FIELDS_DATA';
export const goCashImage              = 'https://gos3.ibcdn.com/goCashIcon-1661489696.png';
export const SET_FLOW = 'SET_FLOW';

const imageBaseUrl : string = 'https://gos3.ibcdn.com/'

// adding images for bluSmart banner and bluSmart tgp modal

export const bluSmartImage          = imageBaseUrl + 'dweb_blusmart-1666244036.png';
export const goAssuredImage         = imageBaseUrl + 'dweb_goAssured-1666246174.png'
export const electricVehicleImage   = imageBaseUrl + 'dweb_electric-vehicle-1666260747.png'
export const cabNotProvidedImage    = imageBaseUrl + 'dweb_cab-not-provided-1666261386.png'
export const cabDelayedImage        = imageBaseUrl + 'dweb_cab-delayed-1666261447.png'
export const ecoFriendlyImage       = imageBaseUrl + 'dweb_env-friendly-1666335674.png'

// constant variables
export const CABS = "cabs";
export const BLANK_VALUE = "";
export const CABS_DWEB = "cars_dweb";
export const rental = "rental";
export const RENTAL_PAGE = "RentalPage";
export const WAY_TYPE_IN = "in";
export const WAY_TYPE_FROM = "from";
export const WAY_TYPE_TO = "to";
export const HR = "hr";
export const PACKAGE_ID = "package_id";
export const PACKAGE_TIME = "packageTime";
export const CACHE_KEY = {
  rental: "cabs_dweb_rental_cabs_in_"
}
export const AEROSPIKE_KEY = {
  rental: "cars_dweb_rental"
}
export const AVAILABLE_CAB_TITLE = {
  rental: "Available Rental Cab in ",
  pageType: "Check Price for ",
  other: "Available Cab from "
}
export const PICKUP_LOC_DETAILS = {
  title: "Pickup Location is Empty",
  error: "Please Enter Your Pickup Location to proceed."
}

export const HR_PACKAGE_IDS = "HR_PACKAGE_IDS"

export const STATIC_RENTAL_TABLE_TITLE              = ' Rental Cabs Prices'
export const VEHICLE_TYPE                           = 'Vehicle Type'
export const MODEL                                  = 'Model'
export const PER_KM_RATE                            = 'Per km Rate'   
export const FARE                                   = 'Fare'
export const INCLUDED                               = 'INCLUDED'
export const VIEW_DETAILS                           = 'View Details'
export const ONE_WAY_CAB                            = 'ow-cab'
export const AT_FAQ                                 = 'Airport Cabs Booking FAQ'
export const HR_FAQ                                 = 'Rental Cabs Booking FAQ'
export const ONE_WAY_CAB_FAQ                        = 'FAQs on One Way Cab Service'
export const DEFAULT_FAQ                            = 'Cabs Booking FAQ'
export const ONE_WAY_CAB_PATHNAME                   = '/cars/one-way-cab/'
export const DEFAULT_H1_TAG                         = 'Book Online Cab'
export const SOURCE_TYPE                            = 'source_type'
export const HOME_PICKUP_ERROR_TXT                  = 'Please select pickup location.'
export const HOME_DROP_ERROR_TXT                    = 'Please select drop location.'
export const HOME_STOP_ERROR_TXT                    = 'Please enter all location.'
export const HOME_PICKUP_DROP_SAME_ERROR_TXT        = 'Pick and drop location can not be same.'
export const HOME_PACKAGE_ERROR_TXT                 = 'Please Select package preference.'
export const USE_AS_BILLING_ADDRESS_TAX             = "Use this as billing address for tax invoice"
export const FLIGHTS_MYTRIPS_DETAILS_PAGE           = "Flights_Mytrips_Details_Page"
export const FLIGHTS_MYTRIPS_DETAILS_PAGE_NEW       = "Flights_Mytrips_Details_Page_new"
export const MAKE_MY_TRIP                           = "MakeMyTrip"    
export const GOIBIBO                                = "Goibibo"
export const SEO                                    = "seo"
export const TRAVELLER_DETAILS                      = "Traveller Details"
export const PLEASE_CONFIRM_TRAVELLER_DETLS         = "Please confirm traveller details"
export const PLEASE_ENTER_FULL_NAME                 = "Please enter full name"
export const PLEASE_ENTER_VALID_EMAIL               = "Please enter valid email"
export const PLEASE_ENTER_VALID_MOBILE_NO           = "Please enter valid mobile number"
export const HOB_BOTTOMSHEET_COMM_TXT               = "Communications regarding bookings will be sent via the shared email and phone number"
export const HOB_BOTTOMSHEET_FULL_NAME              = "FULL NAME"
export const HOB_BOTTOMSHEET_EMAIL                  = "EMAIL ID"
export const HOB_BOTTOMSHEET_MOB_NO                 = "MOBILE NO."
export const HOB_BOTTOMSHEET_CONFIRM_BOOKING        = "Confirm Booking"
export const UNTILL_TEXT                            = "till"


export const DEFAULT_CONTACT_DETAILS = [
  { title: 'Male',   value: 'M' },
  { title: 'Female', value: 'F' },
  { title: 'Others', value: 'O' },
]

export const HOB_CAR_IMG_URL            = "https://gos3.ibcdn.com/hob-car-1713875056.png"
export const HOB_MMT_LOGO_URL           = "https://go-assets.ibcdn.com/u/MMT/images/1715770747938-mmt-brand-icon.png"
export const GOLD_STAR_URL              = "https://gos3.ibcdn.com/gold-star-1713962722.png"
export const WHITE_STAR_URL             = "https://gos3.ibcdn.com/white-star-1713962776.png"
export const DASHED_LINE_URL            = "https://gos3.ibcdn.com/dashed-line-1713962829.png"
export const HOB_TO_IMG_URL             = "https://gos3.ibcdn.com/hob-from-1713876729.png"
export const HOB_FROM_IMG_URL           = "https://go-assets.ibcdn.com/u/GI/images/1721031628018-hob-to.png"
export const HOB_FROM_IMG_URL_DISABLED  = "https://go-assets.ibcdn.com/u/GI/images/1721033652099-hob-cab-from-grey.png"
export const HOB_TO_IMG_URL_DISABLED    = "https://go-assets.ibcdn.com/u/GI/images/1721033800554-hob-cab-to-grey.png"
export const HOB_CHAT_ICON_URL          = "https://gos3.ibcdn.com/hob-chat-1713876851.png"
export const HOB_LEFT_ICON              = "https://gos3.ibcdn.com/hob-left-icon-1714020665.png"
export const HOB_DOWN_ARROW_URL         = "https://gos3.ibcdn.com/hob-down-arrow-1713877018.png"
export const WTI_LOGO_URL               = "https://gos3.ibcdn.com/wti_cabs_logo-1694675041.png"
export const QUICK_RIDE_URL             = "https://gos3.ibcdn.com/quick-ryde-new-icon-1714628464.png"
export const MERU_LOGO_URL              = "https://gos3.ibcdn.com/meru_logo-1694675010.png"  
export const MEGA_LOGO_URL              = "https://gos3.ibcdn.com/mega_logo-1694674995.png"   
export const SAVARI_URL                 = "https://gos3.ibcdn.com/savaari_logo-1694674979.png"
export const GOJO_URL                   = "https://gos3.ibcdn.com/gozo_logo-1694674964.png"
export const PRAKIRTI_URL               = "https://gos3.ibcdn.com/prakriti-new-icon-1714628516.png"
export const BLU_LOGO_URL               = "https://gos3.ibcdn.com/blusmart_logo-1694674911.png"
export const RUNNING_CAR_URL            = 'https://jsak.mmtcdn.com/cabs_cdn_dt/image/HOB/RunningCar.gif'
export const TAXIDA_LOGO_URL            = 'https://jsak.mmtcdn.com/cabs_cdn_dt/image/AT_Suppliers/Taxida.png';
export const HOB_BACK_ICON_URL          = "https://gos3.ibcdn.com/hob-back-icon-1714296479.webp"
export const HOB_EDIT_ICON_URL          = "https://gos3.ibcdn.com/hob-edit-icon-1714370503.webp"
export const HOB_INFO_ICON_URL          = "https://gos3.ibcdn.com/hob-info-icon-1714370581.webp"
export const HOB_DEST_BACK_ICON         = "https://gos3.ibcdn.com/hob-dest-back-icon-1714374092.webp"
export const HOB_BAGGAGE_ICON           = "https://gos3.ibcdn.com/hob-baggage-1714396110.png"
export const HOB_CHEVRON_RIGHT          = "https://gos3.ibcdn.com/hob-chevron-right-1714396241.png"
export const HOB_GREEN_TICK             = "https://gos3.ibcdn.com/hob-green-tick-1714396278.png"
export const HOB_PLACEHOLDER            = "https://gos3.ibcdn.com/hob-place-holder-1714396322.png"  
export const HOB_RIGHT_ARROW            = "https://gos3.ibcdn.com/hob-right-arrow-1714396357.png"
export const GOIBIBO_ICON_URL           = "https://gos3.ibcdn.com/goibibo-icon-1714472749.png"
export const HOB_BOTTOMSHEET_CANCEL     = "https://go-assets.ibcdn.com/u/GI/images/1721047497756-hob-cancel-icon.png"
export const HOB_BOTTOMSHEET_INFO       = "https://go-assets.ibcdn.com/u/GI/images/1721048882099-hob-info-icon.png"
export const HOB_EDIT_FILL_ICON         = "https://go-assets.ibcdn.com/u/GI/images/1726730016495-pencil-edit.png"

export const smallCabLogos = [
  MERU_LOGO_URL,
  QUICK_RIDE_URL,
  MEGA_LOGO_URL,
  PRAKIRTI_URL,
  WTI_LOGO_URL,
];

export const brandCompany = [
  QUICK_RIDE_URL, MERU_LOGO_URL, MEGA_LOGO_URL, WTI_LOGO_URL, PRAKIRTI_URL,GOJO_URL,TAXIDA_LOGO_URL
];

export const PROVISIONAL_HOB_REQUEST_TYPE = 'hobProvisionalRequest';

export const errIcon = 'https://jsak.mmtcdn.com/cabs_cdn_dt/image/addon-error-view-icon.png';

export const errActionCta = {
  text: 'BOOK ANOTHER CAB',
  mmtUrl: 'https://cabs.makemytrip.com/?tripType=AT&source=ProvisionalExpiry',
  giUrl: 'https://www.goibibo.com/cars/?qryParams={%22t_t%22:%22AIRPORT%22,%22rf%22:%22at%22}'
};

export const API_STATUS = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  LOADING: 'loading',
}

export const CONSTANTS = {
  SUCCESS :'SUCCESS',
  OW:'OW',
  holdBookingRequest:'holdBookingRequest',
  V3:'V3',
  ZERO_PAYMENT:'ZERO_PAYMENT',
  KIOSK:'KIOSK',
  hob:'hob',
  hob_funnel: 'hob_funnel',
  departure:'departure',
  thankYouRequest:'thankYouRequest',
  bookMode:'M',
  myTripsText:'Go To My Trips'
}

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const CHAR_DHAM_IMAGES = {
  BG_IMAGE: "https://go-assets.ibcdn.com/u/GI/images/1723544666374-CharDham_BG.jpeg",
  DROP_DOWN:"https://go-assets.ibcdn.com/u/GI/images/1723781818949-drop_down.png",
  SUV: "https://gos3.ibcdn.com/suv_v_2-1576142562.png",
  SEDAN: "https://gos3.ibcdn.com/sedan_v_2_copy_2-1576142484.png",
  LOCATION_ICON: "https://go-assets.ibcdn.com/u/GI/images/1723738539642-location_ic.png",
  RIGHT_ICON: "https://go-assets.ibcdn.com/u/MMT/images/1725174532970-rightIc.png",
  STOPS_ICON: "https://go-assets.ibcdn.com/u/GI/images/1725177292483-dotIc.png",
  THUMB_IMG: "https://go-assets.ibcdn.com/u/GI/images/1723542356254-thumb.png",
  ASSISTANT_GIRL: "https://jsak.mmtcdn.com/cabs_seo_pages/static/public/assistance-call.png",
  CHAR_DHAM_ROUTE: "https://jsak.mmtcdn.com/cabs_seo_pages/static/public/chardham-route.webp",
}

export const CHAR_DHAM_DATA = {
  THINGS_KEEP_IN_MIND: "Things to keep in mind",
  ASSISTANT_TITLE: "Looking to customise your plan?",
  ASSISTANT_SUBTITLE: "Reach out for personalized assistance and trip planning.",
  CHAR_DHAM_HEADER: "Char Dham Cabs",
  CHAR_DHAM_SUBHEADER: "Book Comfortable Cabs for Your Custom Travel Needs",
}

export const CHAR_DHAM_EVENTS = {
  TALK_TO_EXPERT: "talk_to_an_expert_clicked"
}

export const MESH_IMG = "https://go-assets.ibcdn.com/u/GI/images/1740937885237-savaariMesh.webp";
export const SAVAARI = "savaari";
